module.exports = __webpack_public_path__ + "img/ico_landing-events.cb13486a.svg";